export class ListModel {
  icon: string;
  name: string;
  result: string;
  isPositiveResult: boolean;

  constructor(item) {
    this.icon = item.icon || 'fa-question-circle';
    this.name = item.name || '';
    this.result = item.result || '0';
    this.isPositiveResult = item.isPositiveResult || false;
  }
}
